import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 8h16","key":"svg-0"}],["path",{"d":"M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v9","key":"svg-1"}],["path",{"d":"M8 4v4","key":"svg-2"}],["path",{"d":"M16 19h6","key":"svg-3"}]]

const IconBrowserMinus = createReactComponent('outline', 'browser-minus', 'BrowserMinus', __iconNode);

export default IconBrowserMinus;